import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import camelCaseKeys from 'utils/camelCaseKeys'
import {
  set as setSearch
} from 'store/redux/search'

export default function * fetchSearchDesks (action) {
  const { refresh, limit } = action.payload

  if (refresh) {
    yield put(setSearch({
      desks: [],
      desksCursor: null,
      desksTotalCount: null,
      desksLoadedAll: false,
      desksLoading: true
    }))
  } else {
    yield put(setSearch({
      desksLoading: true
    }))
  }

  const state = yield select()

  const { query, refiners, desks, desksCursor, desksSort } = state.kanbo.search

  try {
    const { Layouts, Cursor, Refiners, SortOptions, TotalRows } = yield call(apiGetData, 'SearchBoardCollections', {
      query,
      cursor: desksCursor,
      limit,
      sort: desksSort,
      refiners: Object.keys(refiners.desks).map(key => ({
        id: key,
        ...refiners.desks[key]
      })),
    })

    yield put(setSearch({
      desks: [
        ...desks,
        ...Layouts.map(Layout => ({
          id: Layout.Id,
          name: Layout.Name,
          description: Layout.Description,
          isPublic: Layout.IsPublic,
          isShared: Layout.IsShared,
          isTemplate: Layout.IsTemplate,
          isLocked: Layout.IsLocked,
        }))
      ],
      desksCursor: Cursor,
      desksRefiners: Refiners ? camelCaseKeys(Refiners) : [],
      desksSortOptions: SortOptions ? camelCaseKeys(SortOptions) : [],
      desksTotalCount: TotalRows,
      desksLoadedAll: !Cursor,
      desksLoading: false
    }))
  } catch (error) {
    yield put(setSearch({
      desksLoading: false
    }))

    throw error
  }
}
